import React, { useState } from "react";
import { Button, Collapse, Modal } from "react-bootstrap";

import { useSession } from "../../contexts/SessionContext";
import translate from "../../services/Translate";
import DstButton from "../DstButton/DstButton";
import { DstAlertProps } from "./DstAlert.d";
import "./DstAlert.scss";

const DstAlert = ({
  show,
  onHide,
  type = "info",
  title = "",
  message = "",
  buttons = [],
  showCloseButton = true,
  clickOutsideToClose,
  extraContent,
  showLessText,
  showMoreText,
}: DstAlertProps) => {
  const { language } = useSession();
  const [showMore, setShowMore] = useState(false);

  const isDanger = type === "danger";
  const canCloseOutside = !isDanger && clickOutsideToClose;

  showLessText = showLessText || translate(language, "COMPONENTS.DST_ALERTS.SHOW_LESS");
  showMoreText = showMoreText || translate(language, "COMPONENTS.DST_ALERTS.SHOW_MORE");

  const _renderIcon = () => {
    let bgClass = "blue-background";
    let icon = "dst-icon-info-circle";

    if (type === "success") {
      bgClass = "bg-success";
      icon = "dst-icon-check";
    } else if (type === "danger") {
      bgClass = "bg-danger";
      icon = "dst-icon-alert-triangle";
    } else if (type === "warning") {
      bgClass = "bg-warning";
      icon = "dst-icon-alert-triangle";
    }

    return (
      <div
        className={`dst-alert-icon d-flex justify-content-center align-items-center rounded-circle mx-auto mb-3 position-absolute top-0 start-50 translate-middle ${bgClass}`}
      >
        <span className={`${icon} text-white`} />
      </div>
    );
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop={canCloseOutside ? true : "static"}
      keyboard={canCloseOutside}
      className="dst-alert-modal"
    >
      {!isDanger && showCloseButton && (
        <button onClick={onHide} className="btn-close position-absolute top-0 end-0 m-3 clickable" aria-label="Close" />
      )}

      <Modal.Body className="text-center position-relative pt-5">
        {_renderIcon()}
        <h4 className="mt-4">{title}</h4>
        <p>{message}</p>

        {extraContent && (
          <React.Fragment>
            <div className="mb-3">
              <DstButton
                variant="link"
                value={showMore ? showLessText : showMoreText}
                clickFunction={() => setShowMore((prev) => !prev)}
                btnClass="p-0"
              />
            </div>

            <Collapse in={showMore}>
              <div className="mb-3">{extraContent}</div>
            </Collapse>
          </React.Fragment>
        )}

        {buttons.map((btn: any, index: number) => (
          <Button key={index} variant={btn.variant || "primary"} onClick={btn.onClick} className="m-1">
            {btn.label}
          </Button>
        ))}
      </Modal.Body>
    </Modal>
  );
};

export default DstAlert;
